import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("S-SG5CZtLBFpZj-qC");

export const sendDemoRequest = async (formData: {
  name: string;
  company: string;
  email: string;
  phone: string;
  message: string;
}) => {
  try {
    const response = await emailjs.send(
      "YOUR_SERVICE_ID",
      "YOUR_TEMPLATE_ID",
      {
        to_email: "bizcomfort@jaimy.be",
        from_name: formData.name,
        from_company: formData.company,
        from_email: formData.email,
        from_phone: formData.phone,
        message: formData.message,
      }
    );

    if (response.status !== 200) {
      throw new Error('Failed to send email');
    }

    return response;
  } catch (error) {
    console.error('Error sending demo request:', error);
    throw error;
  }
};